module.exports = __webpack_public_path__ + "assets/a1db81d7175cd65bcd6faeffb276dcb9.png";